import { OrigParams } from '@wix/wix-chatbot-common/browser';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ACTIONS } from '../../../constants';
import { widgetSDK } from '../../sdk/widgetSDK';
import { IMetaUpdateOrigParams } from '../reducers/types';

export const useRequestOriginParams = () => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    const origParams = await widgetSDK.getOrigParams();
    dispatch<IMetaUpdateOrigParams>({
      type: ACTIONS.META_UPDATE_ORIG_PARAMS,
      origPageName: (origParams as OrigParams)?.origPageName,
      origPlatform: (origParams as OrigParams)?.origPlatform,
    });
  }, [dispatch]);
};
